// @mui material components
import Card from "@mui/material/Card";

// Arakan components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAlert from "components/MDAlert";
import FilterIcon from "@mui/icons-material/Money";

// Arakan examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import AuthService from "services/auth-service";
import CrudService from "services/cruds-service";
import { useState, useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AbilityContext } from "Can";
import { useAbility } from "@casl/react";
import FilterProject from "./filter-project";
import StatusOnIcon from "@mui/icons-material/Wifi";
import StatusOffIcon from "@mui/icons-material/WifiOff";
import { Tooltip, IconButton, Grid, Icon } from "@mui/material";

// import BookingCard from "examples/Cards/BookingCard";
import i18n from "i18n";
import MDAvatar from "components/MDAvatar";
import { Add, Edit, Search } from "@mui/icons-material";
import IdCell from "components/table/IdCell";
import DefaultCell from "components/table/DefaultCell";
import CustomerCell from "components/table/CustomerCell";
import MDButton from "components/MDButton";
import CsvDownloadButton from "react-json-to-csv";
import colors from "assets/theme/base/colors";
import moment from "moment";
import momenttz from "moment-timezone";

function Items() {
  let { state } = useLocation();
  const { t } = i18n;

  const ability = useAbility(AbilityContext);
  const [data, setData] = useState([]);
  const [tableData, setTableData] = useState([]);
  // const [statusStatistics, setStatusStatistics] = useState([]);
  const [meta, setMeta] = useState(null);
  const [page, setPage] = useState(1);
  const [limitChange, setLimitChange] = useState(false);
  const [sortVal, setSortVal] = useState(null);
  const [sortUrl, setSortUrl] = useState("&sort=-date_created");
  const [isAdmin, setIsAdmin] = useState(false);
  const [filterUrl, setFilterUrl] = useState(null);
  const [showSettings, setShowSettings] = useState(false);
  const [notification, setNotification] = useState({
    value: false,
    text: "",
  });

  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_API_URL;

  const getProjects = async (filUrl) => {
    const URL = `${filUrl ? `${filUrl}&page=${page}` : `&page=${page}`}`;
    const response = await CrudService.getData(
      `items/projects?fields=*,donations.*,translations.*,target_segments.target_segment_id.translations.name,gallery.*,impl_country_id.translations.name,status_id.translations.name,status_id.color,categories.categories_id.translations.name,tags.tags_id.translations.name&filter[all_amount_required][_eq]=0${URL}`,
    );

    setData(response.data);
    setMeta(response.meta);
  };

  useEffect(() => {
    (async () => {
      // await fetchActiveProjects();
      const { data } = await AuthService.getProfile();
      setIsAdmin(
        ability.can("edit", "projects") || data.role?.name === "Administrator",
      );
    })();
  }, []);

  useEffect(() => {
    getProjects(`${filterUrl || ""}${sortUrl}`);
  }, [page]);

  useEffect(() => {
    getProjects(`${filterUrl || ""}${sortUrl}`);
    setLimitChange(false);
  }, [limitChange]);

  useEffect(() => {
    let val;
    if (sortVal) {
      if (sortVal.id === "project")
        val =
          "translations.name&filter[translations][languages_code][_eq]=ar-SA";
      else if (sortVal.id === "category")
        val =
          "categories.categories_id.translations.name&filter[translations][languages_code][_eq]=ar-SA";
      else if (sortVal.id === "tag")
        val =
          "tags.tags_id.translations.name&filter[translations][languages_code][_eq]=ar-SA";
      else if (sortVal.id === "pStatus")
        val =
          "status_id.translations.name&filter[translations][languages_code][_eq]=ar-SA";
      else if (sortVal.id === "impl_country_id")
        val =
          "impl_country_id.translations.name&filter[translations][languages_code][_eq]=ar-SA";
      else val = sortVal.id;
      setSortUrl(`&sort=${sortVal.desc ? "-" : "+"}${val}`);
    }
  }, [sortVal]);

  useEffect(() => {
    if (page === 1) getProjects(`${filterUrl || ""}${sortUrl}`);
    else if (page !== 1) setPage(1);
  }, [filterUrl, sortUrl]);

  useEffect(() => {
    setTableData(getRows(data));
  }, [data]);

  useEffect(() => {
    if (!state) return;
    setNotification({
      value: state.value,
      text: state.text,
    });
  }, [state]);

  useEffect(() => {
    if (notification.value === true) {
      setTimeout(() => {
        setNotification({
          value: false,
          text: "",
        });
      }, 5000);
    }
  }, [notification]);

  // const updateStatusHandler = async (e, data) => {
  //   let obj;
  //   if (data.status === "published") obj = { status: "draft" };
  //   else obj = { status: "published" };
  //   // await CrudService.updateProjectInfo(obj, data.id);
  //   await CrudService.updateItem(`items/projects/${data.id}`, obj);

  //   getProjects(`${filterUrl || ""}${sortUrl}`);
  //   setNotification({
  //     value: true,
  //     color: "success",
  //     text: "تم الحفظ بنجاح",
  //   });
  // };

  const clickShowProjectDetailsHandler = (id) => {
    navigate(`/projects/edit/project/${id}`);
  };

  // const clickDeleteHandler = async (e, id) => {
  //   try {
  //     if (!confirm(t("confirmDelete"))) {
  //       e.nativeEvent.stopImmediatePropagation();
  //     } else {
  //       /*
  //       you must delete all follow up in this appointment
  //       .....
  //       .....
  //       */
  //       await CrudService.deleteAppointment(id);
  //       // the delete does not send a response
  //       // so I need to get again the appointments to set it and this way the table gets updated -> it goes to the useEffect with data dependecy
  //       const response = await CrudService.getProjects(filterUrl);
  //       setData(response.data);
  //       setNotification({
  //         value: true,
  //         text: t("deleteSuccessfully"),
  //       });
  //     }
  //   } catch (err) {
  //     // it sends error is the category is associated with an item
  //     console.error(err);
  //     if (err.hasOwnProperty("errors")) {
  //       setNotification({
  //         value: true,
  //         text: err.errors[0].title,
  //       });
  //     }
  //     return null;
  //   }
  // };

  const getRows = (info) => {
    let updatedInfo = info.map((row) => {
      return {
        ...row,
        dateCreated: moment(row?.date_created).format("YYYY-MM-DDTHH:mm"),
        project: [
          row?.translations[0]?.name,
          {
            image: `${baseUrl}assets/${row?.translations[0]?.pic}`,
          },
        ],
        name: row?.translations[0]?.name,
        summary: row?.translations[0]?.summary,
        desc: row?.translations[0]?.desc,
        promo_video_url: row?.translations[0]?.promo_video_url,
        category:
          row.categories
            ?.map((cat) => cat?.categories_id?.translations?.[0]?.name)
            ?.filter(Boolean)
            ?.join(", ") || "",
        tag:
          row.tags
            ?.map((tag) => tag?.tags_id?.translations?.[0]?.name)
            ?.filter(Boolean)
            ?.join(", ") || "",
        impl_country_id: row.impl_country_id?.translations[0]?.name,
        pStatus: row.status_id?.translations[0]?.name,
        targets: row?.translations[0]?.targets,
        pic: row?.web_pic,
        date_begin: row?.date_begin,
        date_end: row?.date_end,
      };
    });
    return updatedInfo;
  };

  const col = useMemo(
    () => [
      {
        Header: t("id"),
        accessor: "id",
        Cell: ({ value }) => <IdCell id={value} />,
      },
      {
        Header: "تاريخ إنشاء المشروع",
        accessor: "dateCreated",
        hidden: true,
        Cell: ({ value }) => <DefaultCell value={value} />,
      },
      {
        Header: t("title"),
        accessor: "project",
        Cell: ({ value: [name, data] }) => (
          <CustomerCell
            image={data.image}
            color={data.color || "dark"}
            name={name}
          />
        ),
      },
      {
        Header: "التصنيف",
        accessor: "category",
        width: "10%",
        // hidden: true,
        Cell: ({ value }) => <DefaultCell value={value} />,
      },
      // {
      //   Header: "الوسوم",
      //   accessor: "tag",
      //   width: "10%",
      //   hidden: true,
      //   Cell: ({ value }) => <DefaultCell value={value} />,
      // },
      {
        Header: "الحالة",
        accessor: "pStatus",
        width: "10%",
        // hidden: true,
        Cell: ({ value }) => <DefaultCell value={value} />,
      },
      // {
      //   Header: t("country"),
      //   accessor: "impl_country_id",
      //   width: "10%",
      //   hidden: true,
      //   Cell: ({ value }) => <DefaultCell value={value} />,
      // },
      {
        Header: "عدد المستفيدين",
        accessor: "benficial_num",
        width: "10%",
        hidden: true,
        Cell: ({ value }) => <DefaultCell value={value} />,
      },
      // {
      //   Header: "مدة التنفيذ",
      //   accessor: "period",
      //   width: "10%",
      //   hidden: true,
      //   Cell: ({ value }) => <DefaultCell value={value} />,
      // },
      {
        Header: t("cost"),
        accessor: "cost",
        width: "10%",
        // hidden: true,
        Cell: ({ value }) => <DefaultCell value={value} />,
      },
      {
        Header: "قيمة التبرعات",
        accessor: "donation_amount",
        width: "10%",
        // hidden: true,
        Cell: ({ value }) => <DefaultCell value={value} />,
      },
      {
        Header: "عدد المتبرعين",
        accessor: "num_of_donors",
        width: "10%",
        // hidden: true,
        Cell: ({ value }) => <DefaultCell value={value} />,
      },
      {
        Header: "بداية النشر",
        accessor: "date_begin",
        width: "10%",
        hidden: true,
        Cell: ({ value }) => <DefaultCell value={value} />,
      },
      {
        Header: "نهاية النشر",
        accessor: "date_end",
        width: "10%",
        hidden: true,
        Cell: ({ value }) => <DefaultCell value={value} />,
      },
      {
        Header: t("actions"),
        disableSortBy: true,
        accessor: "",
        Cell: (info) => {
          return (
            <MDBox display="flex" alignItems="center">
              {/* {isAdmin && (
                <MDButton
                  onClick={(e) =>
                    navigate(
                      `/donationManagement/donations/filter/&filter[project_id][id][_eq]=${info.cell.row.original.id}`
                    )
                  }
                  variant="outlined"
                  color={"secondary"}
                  size="medium"
                  iconOnly
                  sx={{ mx: 1, width: "auto", padding: "6px 12px" }}
                >
                  <Icon sx={{ fontWeight: "bold" }}>volunteer_activism</Icon>
                  &nbsp;
                  <Tooltip title="إدارة التبرعات">
                    <span>إدارة التبرعات</span>
                  </Tooltip>
                  <Tooltip title="إدارة التبرعات">
                    <span>{info.cell.row.original.donations?.length || 0}</span>
                  </Tooltip>
                </MDButton>
              )} */}

              {/* {isAdmin && info.cell.row.original.status === "draft" ? (
                <MDButton
                  onClick={(e) =>
                    updateStatusHandler(e, info.cell.row.original)
                  }
                  variant="outlined"
                  color={"error"}
                  size="medium"
                  iconOnly
                  sx={{ mx: 1, width: "auto", padding: "6px 12px" }}
                >
                  <Icon sx={{ fontWeight: "bold" }}>signal_wifi_bad</Icon>
                  &nbsp;
                  <Tooltip title="النشر">
                    <span>النشر</span>
                  </Tooltip>
                </MDButton>
              ) : isAdmin && info.cell.row.original.status !== "draft" ? (
                <MDButton
                  onClick={(e) =>
                    updateStatusHandler(e, info.cell.row.original)
                  }
                  variant="outlined"
                  color={"success"}
                  size="medium"
                  iconOnly
                  sx={{ mx: 1, width: "auto", padding: "6px 12px" }}
                >
                  <Icon sx={{ fontWeight: "bold" }}>signal_wifi_4_bar</Icon>
                  &nbsp;
                  <Tooltip title="إيقاف النشر">
                    <span> النشر</span>
                  </Tooltip>
                </MDButton>
              ) : null} */}
              {isAdmin && (
                // <MDButton
                //   sx={{ mx: 1, width: "auto", padding: "6px 12px" }}
                //   variant="outlined"
                //   color={"info"}
                //   size="medium"
                //   iconOnly
                //   onClick={() =>
                //     clickShowProjectDetailsHandler(info.cell.row.original.id)
                //   }
                // >
                //   <Icon sx={{ fontWeight: "bold" }}>edit</Icon>
                //   &nbsp;
                //   <Tooltip title="عرض التفاصيل">
                //     <span>عرض التفاصيل</span>
                //   </Tooltip>
                // </MDButton>
                <MDButton
                  variant="outlined"
                  color="info"
                  onClick={() =>
                    clickShowProjectDetailsHandler(info.cell.row.original.id)
                  }
                >
                  <Tooltip title="عرض التفاصيل">
                    <span> عرض التفاصيل </span>
                  </Tooltip>
                  &nbsp;
                  <Icon>edit</Icon>
                </MDButton>
              )}
              {isAdmin && (
                // <MDButton
                //   sx={{ mx: 1, width: "auto", padding: "6px 12px" }}
                //   variant="outlined"
                //   color={"primary"}
                //   size="medium"
                //   iconOnly
                //   onClick={() => {
                //     if (navigator.clipboard) {
                //       navigator.clipboard.writeText(
                //         "https://staging.arakanha.online/ar/projects/86?influencerId=",
                //       );
                //     } else {
                //       console.log("Clipboard not supported");
                //     }
                //     // navigator.clipboard.writeText("Hello World")
                //   }}
                // >
                //   <Icon sx={{ fontWeight: "bold" }}>star</Icon>
                //   &nbsp;
                //   <Tooltip title="نسخ رابط لمؤثر">
                //     <span>نسخ رابط لمؤثر</span>
                //   </Tooltip>
                // </MDButton>
                <MDButton
                  sx={{ mx: 1 }}
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    if (navigator.clipboard) {
                      navigator.clipboard.writeText(
                        "https://staging.arakanha.online/ar/projects/86?influencerId=",
                      );
                    } else {
                      console.log("Clipboard not supported");
                    }
                  }}
                >
                  <Tooltip title="نسخ رابط لمؤثر">
                    <span>نسخ رابط لمؤثر </span>
                  </Tooltip>
                  &nbsp;
                  <Icon>star</Icon>
                </MDButton>
              )}
            </MDBox>
          );
        },
      },
    ],
    [isAdmin],
  );

  const clickAddHandler = () => {
    navigate("/projects/add/project");
  };

  const getCsvRows = (info) => {
    let updatedInfo = info.map((row) => {
      let csv = {
        "الرقم التسلسلي": row.id,
        "اسم المشروع": row?.translations[0]?.name,
        التصنيفات:
          row.categories
            ?.map((cat) => cat?.categories_id?.translations?.[0]?.name)
            ?.filter(Boolean)
            ?.join(", ") || "",
        "الفئة المستهدفة":
          row.target_segments
            ?.map((ts) => ts?.target_segment_id?.translations?.[0]?.name)
            ?.filter(Boolean)
            ?.join(", ") || "",
        "بلد التنفيذ": row.impl_country_id?.translations[0]?.name,
        الحالة: row.status_id?.translations[0]?.name,
        "تاريخ النشر": row?.date_begin
          ? moment(row?.date_begin).format("YYYY-MM-DDTHH:mm")
          : "",
        "تاريخ الإنتهاء": row?.date_end
          ? moment(row?.date_end).format("YYYY-MM-DDTHH:mm")
          : "",
        "عدد المستفيدين": row.benficial_num,
        التكلفة: row.cost,
        "قيمة التبرعات": row.donation_amount,
        "عدد المتبرعين": row.num_of_donors,
      };

      const keys = Object.keys(csv);
      let csvObj = {};
      keys.forEach((element) => {
        csvObj[t(element)] = csv[element];
      });
      return csvObj;
    });
    return updatedInfo;
  };

  return (
    <DashboardLayout>
      <MDBox pb={3}>
        <MDBox mb={3}>
          <Card sx={{ mb: 1 }}>
            <MDBox
              p={3}
              lineHeight={1}
              display="flex"
              justifyContent="space-between"
            >
              <MDTypography variant="h5" fontWeight="medium" color="info">
                {t("projectManagement")}
              </MDTypography>
              <MDBox>
                {isAdmin && (
                  // <IconButton size="large" onClick={clickAddHandler}>
                  //   <Add color="info" />
                  // </IconButton>
                  <MDButton
                    onClick={clickAddHandler}
                    variant="outlined"
                    color={"info"}
                    size="medium"
                    iconOnly
                    sx={{ mx: 1, width: "auto", padding: "6px 12px" }}
                  >
                    <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                    &nbsp;
                    <Tooltip title=" إضافة مشروع جديد">
                      <span>إضافة مشروع جديد </span>
                    </Tooltip>
                  </MDButton>
                )}
                {/* <IconButton
                  size="large"
                  onClick={() => setShowSettings(!showSettings)}
                >
                  <Search color="info" />
                </IconButton> */}
                <MDButton
                  onClick={() => setShowSettings(!showSettings)}
                  variant="outlined"
                  color={"info"}
                  size="medium"
                  iconOnly
                  sx={{ mx: 1, width: "auto", padding: "6px 12px" }}
                >
                  <Icon sx={{ fontWeight: "bold" }}>search</Icon>
                  &nbsp;
                  <Tooltip title=" بحث">
                    <span>بحث </span>
                  </Tooltip>
                </MDButton>
                {isAdmin && (
                  <CsvDownloadButton
                    data={getCsvRows(data)}
                    style={{
                      backgroundColor: "white",
                      color: colors.info.main,
                      borderColor: "#FF5528",
                      borderWidth: 1,
                      fontSize: "16px",
                      borderRadius: "6px",
                      fontWeight: "bold",
                      width: "auto",
                      padding: "8px 12px",
                      marginRight: "8px",
                    }}
                  >
                    <Icon sx={{ fontWeight: "bold" }}>import_export</Icon>
                    &nbsp;
                    <Tooltip title="تصدير">
                      <span> تصدير </span>
                    </Tooltip>
                  </CsvDownloadButton>
                )}
                {/* <MDBox sx={{ cursor: "pointer" }}>
                    <CsvDownloadButton
                      sx={{ cursor: "pointer" }}
                      data={getCsvRows(data)}
                      style={{
                        backgroundColor: "rgb(37 37 39)",
                        color: "#fff", 
                        fontSize: "15px",
                        fontWeight: "bold",
                        padding: "6px 24px",
                        borderRadius: "6px",
                      }}
                      delimiter=","
                    >
                      {t("export")}
                    </CsvDownloadButton>
                  </MDBox> */}
              </MDBox>
            </MDBox>
          </Card>
          {notification.value === true && (
            <MDAlert color={notification.color} mt="20px">
              <MDTypography variant="body2" color="white">
                {notification.text}
              </MDTypography>
            </MDAlert>
          )}
          <Grid container spacing={1}>
            <Grid item xs={12} lg={showSettings ? 9.5 : 12}>
              <DataTable
                setLimitChange={setLimitChange}
                table={{ columns: col, rows: tableData }}
                meta={meta}
                setPage={setPage}
                setSortVal={setSortVal}
                pageNum={page}
                isSorted={true}
                canAddCol={true}
                canSearch={false}
              />
            </Grid>
            {showSettings && (
              <Grid item xs={12} lg={2.5}>
                <Card>
                  <FilterProject
                    setFilterUrl={setFilterUrl}
                    filterUrl={filterUrl}
                  />
                </Card>
              </Grid>
            )}
          </Grid>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Items;
